(function() {
  function init() {
    var input = document.querySelector('#kv-animated-search-input');
    if (!input) return;

    var phrases = [
      "Search for Mustard Oil",
      "Search for Jaggery Powder",
      "Search for Organic Turmeric"
    ];

    var currentPhrase = 0;
    var idx = 0;
    var direction = 1; 
    var timer = null;

    function step() {
      if (document.activeElement === input) {
        if (timer) clearTimeout(timer);
        return;
      }

      var text = phrases[currentPhrase];
      input.setAttribute('placeholder', text.slice(0, idx));
      idx += direction;

      if (idx > text.length) {
        direction = -1;
        idx = text.length;
        timer = setTimeout(step, 800);   // pause at full text (shorter pause too)
        return;
      } else if (idx < 0) {
        direction = 1;
        currentPhrase = (currentPhrase + 1) % phrases.length;
        idx = 0;
      }

      timer = setTimeout(step, 80);      // faster typing (80ms per char)
    }

    input.addEventListener('focus', function() {
      input.setAttribute('placeholder', '');
    });

    input.addEventListener('blur', function() {
      idx = 0;
      direction = 1;
      step();
    });

    step();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
